import { FileUploadOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import {
  useSysAccountCreateAccountsCsvMutation,
  useSysAccountCreateAccountsMutation,
} from "@/api/hooks/sys-account-hooks";
import BulkOperationReportModal from "@/components/bulk-operation-report-modal";
import ImportAccountsModal from "@/components/config-modals/import-accounts-modal";
import { ResultDtoSysAccountRegularDto, SysAccountCreateDto } from "@/shared/api";

const ImportAccountsTableControl = ({
  roomName,
  onSuccess,
}: {
  roomName: string;
  onSuccess?: (data: ResultDtoSysAccountRegularDto[]) => void;
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [operationResult, setOperationResult] = useState<ResultDtoSysAccountRegularDto[]>();

  const { mutate: createAccountsCsvMutate, isPending: createAccountsCsvIsPending } =
    useSysAccountCreateAccountsCsvMutation();

  function handleCreateAccounts(csvFile: File) {
    createAccountsCsvMutate(
      {
        domain: roomName,
        csvFile: csvFile,
      },
      {
        onSuccess: (response) => {
          setIsOpen(false);
          setOperationResult(response.data);
          onSuccess && onSuccess(response.data);
        },
        onError: (error) => {
          enqueueSnackbar(t("importAccountsTableControl.errorWhileCreatingElements"), {
            variant: "error",
          });
          console.error("Something went wrong while creating elements", error);
        },
      }
    );
  }

  return (
    <>
      <Button onClick={() => setIsOpen(true)}>
        <FileUploadOutlined /> {t("importCsv")}
      </Button>
      {isOpen && (
        <ImportAccountsModal
          title={t("addAccountsBulk")}
          isOnSaveResponsePending={createAccountsCsvIsPending}
          onSave={(csvFile) => handleCreateAccounts(csvFile)}
          onCancel={() => setIsOpen(false)}
        />
      )}
      {operationResult != null && (
        <BulkOperationReportModal
          open
          showProblematic
          showSuccess
          title={t("importAccountsTableControl.operationResultTitle")}
          resultList={operationResult}
          onCancel={() => setOperationResult(undefined)}
        />
      )}
    </>
  );
};

export default ImportAccountsTableControl;
